import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox';
import { Check } from 'lucide-react';
import { useId } from 'react';

/** docs/spec/06 §2 Checkbox: 22 px box, accent fill when checked, label + optional caption. */
export function Checkbox({
  checked,
  onChange,
  label,
  caption,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  caption?: string;
}) {
  const id = useId();
  return (
    <div className="flex min-h-10 items-center gap-3">
      <BaseCheckbox.Root
        id={id}
        checked={checked}
        onCheckedChange={(v) => onChange(v)}
        className="flex size-[22px] shrink-0 items-center justify-center rounded-xs border-2 border-border-strong data-[checked]:border-accent data-[checked]:bg-accent"
      >
        <BaseCheckbox.Indicator className="text-accent-ink">
          <Check size={16} strokeWidth={3} aria-hidden />
        </BaseCheckbox.Indicator>
      </BaseCheckbox.Root>
      <label htmlFor={id} className="flex cursor-pointer flex-col">
        <span className="t-label">{label}</span>
        {caption ? <span className="t-caption text-dim">{caption}</span> : null}
      </label>
    </div>
  );
}
